export default __webpack_public_path__ + "static/media/pikachu-cover.e98831c1.png";